import { useLayoutEffect } from 'react';
/** Leases belong to committed consumers, including consumers reused by React memoization. */
export function useGpuResources(cache, resources) {
    useLayoutEffect(() => cache.retain(resources));
}
